/*
  File: src/components/layout/Footer.jsx
  Purpose: Simple site-wide footer with copyright notice.
*/
import React from 'react';
import { useModal } from '../../contexts/ModalContext';
import PrivacyPolicyContent from '../PrivacyPolicyContent';
import TermsOfServiceContent from '../TermsOfServiceContent';
import SupportContent from '../SupportContent';

function Footer() {
    const year = new Date().getFullYear();
    const { openModal } = useModal();

    const handlePrivacyClick = (e) => {
        e.preventDefault();
        openModal("Privacy Policy", <PrivacyPolicyContent />);
    };

    const handleTermsClick = (e) => {
        e.preventDefault();
        openModal("Terms of Service", <TermsOfServiceContent />);
    };

    const handleSupportClick = (e) => {
        e.preventDefault();
        openModal("Support", <SupportContent />);
    };

    return (
        <footer className="mt-auto backdrop-blur bg-backgroundDark/80 border-t border-white/10 shadow-[0_-2px_20px_rgba(0,0,0,0.35)]">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-14 sm:h-16 flex items-center justify-between text-xs sm:text-sm">
                <div className="text-white/70">© {year} SceneShop</div>
                <div className="flex items-center gap-4 text-white/60">
                    <a href="#" onClick={handlePrivacyClick} className="hover:text-white/90">Privacy</a>
                    <a href="#" onClick={handleTermsClick} className="hover:text-white/90">Terms</a>
                    <a href="#" onClick={handleSupportClick} className="hover:text-white/90">Support</a>
                </div>
            </div>
        </footer>
    );
}

export default Footer;



